import { chunk } from "lodash";
import { useState } from "react";

import type { Pro014StepFourItem } from "@/@types/campaign";
import type { CampaignConflictItem, IValidateConflictsResponse } from "@/@types/campaign-conflict";
import { useValidatePro014ConflictsMutation } from "@/services/campaign-pro014";

import { mergeConflicts } from "../../utils/conflict-resolution";
import { buildConflictValidationRequest } from "../../utils/pro014-payload";
import { CONFLICT_PREVALIDATION_CHUNK_SIZE } from "../constants";
import type {
  Pro014ConflictPrevalidation,
  Pro014PrevalidationInput,
  ValidationProgress,
} from "../types";

export function usePro014ConflictPrevalidation(): Pro014ConflictPrevalidation {
  const [validateConflicts] = useValidatePro014ConflictsMutation();
  const [validationProgress, setValidationProgress] = useState<ValidationProgress | null>(null);

  const prevalidate = async (input: Pro014PrevalidationInput): Promise<CampaignConflictItem[]> => {
    const chunks: Pro014StepFourItem[][] = chunk(input.items, CONFLICT_PREVALIDATION_CHUNK_SIZE);
    const found: CampaignConflictItem[] = [];
    try {
      for (const [index, chunk] of chunks.entries()) {
        setValidationProgress({ current: index + 1, total: chunks.length });
        const result: IValidateConflictsResponse = await validateConflicts(
          buildConflictValidationRequest(input, chunk),
        ).unwrap();
        found.push(...result.conflicts);
      }
    } finally {
      setValidationProgress(null);
    }
    return mergeConflicts(found);
  };

  return { prevalidate, validationProgress };
}
